export default __webpack_public_path__ + "static/media/photo_one.b900950b.jpg";